import { FC, PropsWithChildren } from 'react';
import * as styles from './PriceDynamicWrapper.css';

export const PriceDynamicWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
